import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getDetailedLocationDays} from "../../../../selectors/animalDocumentsSelectors";
import {useCallback, useMemo, useRef} from "react";
import FatteningHeader from "../components/FatteningHeader";
import {getEventsForAnimalsFattening} from "../../../../utils/EventUtils";
import {getTranslationEventKey} from "../../../../utils/RaportsUtils";
import {formatLocationName} from "../../../../utils/global-formatters/formatLocationName";
import moment from "moment";
import {convertWeightUnitTo} from "../../../../utils/UnitUtils";
import {getAnimalUnit} from "../../../../utils/SettingsUtils";
import "../../css/_fattening-grid.scss";
import useLocalStorage from "../../../../hooks/useLocalStorage";

export default function FatteningAnimalsAmountDetailedTable() {
    const {t} = useTranslation();

    const animalUnit = useRef(getAnimalUnit());

    const {locations, detailedData} = useSelector(getDetailedLocationDays);

    const [debugDetailedGroup] = useLocalStorage("debugDetailedGroup", false);

    const getCellClassName = useCallback((type) => {
        let className = "p-2";
        if (type) className += ` color-${type}`;
        return className;
    }, []);

    const amountFormatter = useCallback((element, property) => {
        const showZero = !!element.summary.final && property !== "weight";
        const amount = element[property].amount;
        const value =
            property === "weight"
                ? convertWeightUnitTo(amount, {
                      unit: animalUnit.current,
                      showUnit: true,
                  })
                : amount;
        if (value || showZero)
            return <strong className="opacity-75">{value || 0}</strong>;
        return "-";
    }, []);

    const {detailedHeaders, detailedElements} = useMemo(() => {
        const detailedHeaders = [
            <FatteningHeader top key={"date"}>
                {t("date")}
            </FatteningHeader>,
            <FatteningHeader top key={"pigDays"}>
                {t("pigDays")}
            </FatteningHeader>,
            ...getEventsForAnimalsFattening().map((code) => (
                <FatteningHeader top key={`header_${code}`}>
                    {t(getTranslationEventKey(code))}
                </FatteningHeader>
            )),
            <FatteningHeader summary top key="sum">
                {t("results.sum")}
            </FatteningHeader>,
            <FatteningHeader top key="weight">
                {t("weight")}
            </FatteningHeader>,
            ...Object.keys(locations).map((locationKey, index) => (
                <FatteningHeader top key={locationKey + "_" + index}>
                    {formatLocationName(locationKey.split("_")[1])}
                </FatteningHeader>
            )),
        ];
        const detailedElements = [];
        for (let i = 0; i < detailedData.length; i++) {
            const element = detailedData[i];
            const isFinal = !!element.summary.final;
            for (const property in element) {
                if (property === "date") {
                    detailedElements.push(
                        <FatteningHeader
                            key={`${element.date}_${property}_${i}`}>
                            {isFinal && t("summary")}
                            {/* {isFinal
                                ? t("summary")
                                : moment(element[property]).format(
                                      moment.HTML5_FMT.DATE
                                  )} */}
                            {!isFinal && (
                                <div>
                                    <div>
                                        {moment(element[property]).format("L")}
                                    </div>
                                    {debugDetailedGroup && (
                                        <small>{element[property]}</small>
                                    )}
                                </div>
                            )}
                        </FatteningHeader>
                    );
                } else {
                    detailedElements.push(
                        <div
                            key={`${element.date}_${property}_${i}`}
                            className={getCellClassName(element[property].type)}
                            id={`cy-${property}_${element["date"]}`}>
                            {amountFormatter(element, property)}
                        </div>
                    );
                }
            }
        }
        return {detailedHeaders, detailedElements};
    }, [
        amountFormatter,
        getCellClassName,
        detailedData,
        locations,
        t,
        debugDetailedGroup,
    ]);

    const detailedColumns = detailedHeaders.length;

    return (
        <div
            className="grid-wrapper"
            style={{
                "grid-template-columns": `repeat(${detailedColumns}, 1fr)`,
            }}>
            {detailedHeaders}
            {detailedElements}
        </div>
    );
}
